import React from "react";
import PropTypes from "prop-types";
import "./EmptyState.css";

/**
 * Reusable empty state component
 * Displays a centered message when no data is available
 */
const EmptyState = ({
  icon = null,
  message,
  subtitle = null,
  action = null,
  className = "",
}) => {
  return (
    <div className={`empty-state ${className}`}>
      {icon && <div className="empty-state-icon">{icon}</div>}
      <p className="empty-state-message">{message}</p>
      {subtitle && <p className="empty-state-subtitle">{subtitle}</p>}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  );
};

EmptyState.propTypes = {
  icon: PropTypes.node,
  message: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  action: PropTypes.node,
  className: PropTypes.string,
};

export default EmptyState;
